import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import VisualCsmlNew from './visual/New.vue';
import VisualCsmlEdit from './visual/Edit.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import store from 'dashboard/store';

const requireCsmlFlow = (to, _from, next) => {
  const accountId = Number(to.params.accountId);
  const enabled = store.getters['accounts/isFeatureEnabledonAccount'](
    accountId,
    FEATURE_FLAGS.CSML_FLOW
  );

  if (enabled) {
    next();
    return;
  }

  next(frontendURL(`accounts/${accountId}/settings/agent-bots`));
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      name: 'agent_bots_settings',
      meta: {
        permissions: ['administrator'],
        showOnlyForSuperAdmin: true,
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'visual-csml/new',
          name: 'agent_bots_visual_csml_new',
          component: VisualCsmlNew,
          beforeEnter: requireCsmlFlow,
          meta: {
            featureFlag: FEATURE_FLAGS.CSML_FLOW,
            permissions: ['administrator'],
            fullBleed: true,
          },
        },
        {
          path: 'visual-csml/:botId/edit',
          name: 'agent_bots_visual_csml_edit',
          component: VisualCsmlEdit,
          beforeEnter: requireCsmlFlow,
          meta: {
            featureFlag: FEATURE_FLAGS.CSML_FLOW,
            permissions: ['administrator'],
            fullBleed: true,
          },
        },
      ],
    },
  ],
};
